import React, { useState } from 'react';
import CommonModal from '@/components/ui/modals/CommonModal';

const ProductCautionModal = ({ modelTitle, itemDescription, modalOpen, setModalOpen }) => {
    const handleModelClose = () => {
        setModalOpen(false);
    };

    return (
        <CommonModal addonsclassName={'ff-modal info-modal'} modelTitle={modelTitle} openModel={modalOpen} handleModelClose={handleModelClose}>
            {itemDescription}
        </CommonModal>
    );
};

export default ProductCautionModal;
